let NavList = [
    {
      title:"首页",
      type:"01",
      path:"/index",
    },
    {
      title:"工作动态",
      type:"01",
      path:"/gzdt",
    },
    {
      title:"公示公告",
      type:"01",
      path:"/gsgg",
    },
    {
      title:"机构设置",
      type:"01",
      path:"/jgsz",
    },
    {
      title:"学习教育",
      type:"01",
      path:"/wyzx",
    },
    {
      title:"社情民意",
      type:"01",
      path:"/sqmy",
    },
    {
      title:"提案工作",
      type:"01",
      path:"/tagz",
    },
    {
      title:"文史资料",
      type:"01",
      path:"/wszl",
    },
    {
      title:"委员风采",
      type:"01",
      path:"/dyfc",
    },
    {
      title:"书香政协",
      type:"01",
      path:"/Ztjyzl",
    }
  ]

export default NavList 